import Http from '@/services/http';
import { NotificationResource } from 'sigma-mappings';

const urls = {
  getNotifications: resourceId => `/recursos/${resourceId}/notificacoes`,
};

export default {
  getNotificationsByResourceId(resourceId) {
    const http = new Http();
    return http.get(urls.getNotifications(resourceId))
      .then(({ data }) => data.map(item => new NotificationResource(item)));
  },
};
